import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { createChangeRequest as apiCreateChangeRequest } from 'partner360/features/hpContacts/api'

import { prefillChangeRequest } from '../../lib/prefillChangeRequest'
import { selectWelcomeFlowMissingPartners, selectWelcomeFlowUserData } from '../selectors'

type IPartnerId = string

interface IRequestPayload {
  partnerIds: IPartnerId[]
}

export const requestCreateChangeRequests = createAsyncThunk<
  void,
  IRequestPayload,
  { rejectValue: Error }
>('welcomeFlow/requestCreateChangeRequests', async ({ partnerIds }, { getState }) => {
  const userData = selectWelcomeFlowUserData(getState())
  const missingAssignments = selectWelcomeFlowMissingPartners(getState())

  const filtered = missingAssignments.filter((it) => partnerIds.includes(it.PartnerID))

  const results = await Promise.all(
    filtered.map(async (partner) => {
      try {
        const prefilledRequest = prefillChangeRequest(userData, partner.PartnerID)
        await apiCreateChangeRequest({
          request: {
            ...prefilledRequest,
            Roles: partner.Role,
            BusinessUnit: partner.BusinessUnit,
            RequestAction: 'Add',
          },
        })

        return { success: true, partnerId: partner.PartnerID }
      } catch (error) {
        return { success: false, error: error as Error, partnerId: partner.PartnerID }
      }
    })
  )

  const failed = results.filter((r) => !r.success)
  if (failed.length > 0) {
    console.warn(`Failed to create change requests for ${failed.length} partners`)
  }

  return
})
